import React, { memo } from 'react';
import Tooltip from '@atlaskit/tooltip';
import AsyncIcon from '@atlassian/jira-common-components-async-icon/src/view.tsx';
import { useIntl } from '@atlassian/jira-intl/src/index.tsx';
import messages from './messages.tsx';
import { Wrapper } from './styled.tsx';
import type { Props } from './types.tsx';

const priorityIconSize = 20;

const Priority = memo<Props>(({ iconUrl, name }: Props) => {
	const intl = useIntl();
	const title = intl.formatMessage(messages.issuePriorityTitle, { issuePriorityName: name });

	return (
		<Wrapper>
			<Tooltip
				content={name}
				position="bottom"
				testId="servicedesk-insight-object-issue-card.ui.priority.tooltip"
			>
				<AsyncIcon alt={title} url={iconUrl} width={priorityIconSize} height={priorityIconSize} />
			</Tooltip>
		</Wrapper>
	);
});

export default Priority;
